import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Processing() {
  const navigate = useNavigate();

  useEffect(() => {
    // Results will arrive via navigate from Onboarding
    // This page just shows while we wait
  }, []);

  const steps = [
    'Parsing your resume...',
    'Scanning job description...',
    'Calculating ATS match...',
    'Generating resume improvements...',
    'Building interview prep...',
  ];

  return (
    <div style={{ background: '#0A0F1E', minHeight: '100vh', color: 'white', fontFamily: 'Arial, sans-serif', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
      <span
  onClick={() => navigate('/')}
  style={{ color: '#00D4AA', fontWeight: 'bold', fontSize: '2rem', marginBottom: '2rem', cursor: 'pointer' }}>
  CrackPrep
</span>

      {/* Spinner */}
      <div style={{ width: '60px', height: '60px', border: '4px solid #1a2640', borderTop: '4px solid #00D4AA', borderRadius: '50%', animation: 'spin 1s linear infinite', marginBottom: '2rem' }} />

      <h2 style={{ marginBottom: '1.5rem' }}>Analysing your profile...</h2>
      <p style={{
  color: '#8899aa',
  fontSize: '0.85rem',
  marginTop: '1.5rem',
  textAlign: 'center',
  maxWidth: '300px',
  lineHeight: 1.6,
}}>
  Processing underway. Please wait for 5–7 minutes.<br />
  Do not refresh or press the back button.
</p>

      <div style={{ textAlign: 'left', maxWidth: '320px' }}>
        {steps.map((s, i) => (
          <div key={s} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem', color: '#8899aa' }}>
            <span style={{ color: '#00D4AA' }}>⟳</span>
            <span>{s}</span>
          </div>
        ))}
      </div>

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}